import { useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import { Container, FullRow, Title } from "../../components"
import { CheckCircleOutlined, MailOutlined, InfoCircleOutlined } from "@ant-design/icons"
import { useTheme } from "styled-components"

export function RegistrationSuccess(): JSX.Element {
    const theme = useTheme()
    const location = useLocation()
    const userEmail = location.state?.email || "your email"
    const userName = location.state?.name || "there"

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0)
    }, [])

    return (
        <Container style={{ marginTop: "3.5em", textAlign: "center" }}>
            <FullRow>
                <div style={{ 
                    display: "flex", 
                    flexDirection: "column", 
                    alignItems: "center", 
                    gap: "1.5rem",
                    maxWidth: "600px",
                    margin: "0 auto",
                    padding: "2rem",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "12px",
                    border: "1px solid #e0e0e0"
                }}>
                    <CheckCircleOutlined 
                        style={{ 
                            fontSize: "4rem", 
                            color: "#52c41a" 
                        }} 
                    />
                    
                    <Title style={{ 
                        color: theme.primary, 
                        marginBottom: 0,
                        fontSize: "2rem"
                    }}>
                        Registration Successful!
                    </Title>
                    
                    <p style={{ 
                        fontSize: "1.1rem", 
                        color: "#666", 
                        lineHeight: "1.6",
                        margin: "0 0 1rem 0"
                    }}>
                        Thank you for registering with PLab Sequencing, <strong>{userName}</strong>!
                    </p>
                    
                    <div style={{
                        backgroundColor: "#e6f7ff",
                        border: "1px solid #91d5ff",
                        borderRadius: "8px",
                        padding: "1.5rem",
                        width: "100%",
                        textAlign: "left"
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1rem" }}>
                            <MailOutlined style={{ color: theme.primary, fontSize: "1.2rem" }} />
                            <h3 style={{ margin: 0, color: theme.primary }}>Check Your Email</h3>
                        </div>
                        <p style={{ margin: "0 0 1rem 0", color: "#333" }}>
                            We've sent an activation email to:
                        </p>
                        <p style={{ 
                            fontWeight: "bold", 
                            color: theme.primary,
                            backgroundColor: "white",
                            padding: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #d9d9d9",
                            margin: "0 0 1rem 0"
                        }}>
                            {userEmail}
                        </p>
                        <p style={{ margin: 0, color: "#666" }}>
                            Please click the activation link in the email to complete your registration.
                        </p>
                    </div>
                    
                    <div style={{
                        backgroundColor: "#fff7e6",
                        border: "1px solid #ffd591",
                        borderRadius: "8px",
                        padding: "1rem",
                        width: "100%",
                        textAlign: "left"
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.5rem" }}>
                            <InfoCircleOutlined style={{ color: "#fa8c16", fontSize: "1.1rem" }} />
                            <strong style={{ color: "#fa8c16" }}>Important Notes:</strong>
                        </div>
                        <ul style={{ margin: 0, paddingLeft: "1.5rem", color: "#666" }}>
                            <li>The activation link will expire in 24 hours</li>
                            <li>Check your spam/junk folder if you don't see the email</li>
                            <li>You must activate your account before you can log in</li>
                        </ul>
                    </div>
                    
                    <div style={{ 
                        display: "flex", 
                        gap: "1rem", 
                        marginTop: "1rem",
                        flexWrap: "wrap",
                        justifyContent: "center"
                    }}>
                        <Link 
                            to="/login" 
                            style={{ 
                                backgroundColor: theme.primary,
                                color: "white",
                                padding: "0.75rem 1.5rem",
                                borderRadius: "6px",
                                textDecoration: "none",
                                fontWeight: "500",
                                border: "none",
                                cursor: "pointer",
                                transition: "background-color 0.2s"
                            }}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#1890ff"}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = theme.primary}
                        >
                            Go to Login
                        </Link>
                        
                        <Link 
                            to="/" 
                            style={{ 
                                backgroundColor: "transparent",
                                color: theme.primary,
                                padding: "0.75rem 1.5rem",
                                borderRadius: "6px",
                                textDecoration: "none",
                                fontWeight: "500",
                                border: `1px solid ${theme.primary}`,
                                cursor: "pointer",
                                transition: "all 0.2s"
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = theme.primary
                                e.currentTarget.style.color = "white"
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = "transparent"
                                e.currentTarget.style.color = theme.primary
                            }}
                        >
                            Return to Home
                        </Link>
                    </div>
                </div>
            </FullRow>
        </Container>
    )
}
